import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useSelector } from "react-redux";
import { fetchSignUpDistribution } from "../../../api/nystats";
import { MobileMobileIcon, DesktopIcon, MobileWebIcon } from "../../../icons";

export default function SignUpDistribution({platform,isLoading}) {
  const [platformData, setPlatformData] = useState([]);

  const getIcon = (label) => {
    if (/mobile app/i.test(label)) return <MobileMobileIcon />;
    return <DesktopIcon />;
  };

  useEffect(() => {
    const load = async () => {
      try {
        // const { platform } = await fetchSignUpDistribution(filter);
        
        // platform: [{ label, count, percent }]
        const mapped = platform.map((p) => ({
          icon: getIcon(p.label),
          label: p.label,
          value: p.count,
          percent: p.percent,
        }));
        setPlatformData(mapped);
      } catch (e) {
        console.error("Error loading sign-up distribution", e);
        setPlatformData([]);
      }
    };
    load();
  }, [platform]);

  const totalUsers = platformData.reduce((sum, item) => sum + item.value, 0);

  const pieOptions = {
    chart: { type: "pie", height: 260 },
    title: { text: "" },
    credits: { enabled: false },
    tooltip: {
      formatter: function () {
        const d = platformData.find((p) => p.label === this.point.name);
        if (!d) return "";
        return `
          <b>${this.point.name}</b><br/>
          Users: <b>${d.value.toLocaleString()}</b><br/>
          Share: <b>${d.percent}%</b>
        `;
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b>: {point.y}%",
        },
      },
    },
    series: [
      {
        name: "Sign-Ups",
        colorByPoint: true,
        colors: ["#10B981", "#3B82F6", "#8B5CF6"],
        data: platformData.map((item) => ({
          name: item.label,
          y: item.percent,
        })),
      },
    ],
  };

  return (
    <Box
      sx={{
        border: "1px solid #e6e6e6",
        borderRadius: "12px",
        p: 2,
        background: "#fff",
      }}
    >
      <Typography
        sx={{
          fontSize: "18px",
          fontWeight: 500,
          color: "#101828",
          mb: 3,
          borderLeft: "3px solid #FBBF24",
          pl: 1,
        }}
      >
        Sign-Up Distribution by Platform
      </Typography>

      {
        isLoading ? <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="body1" color="text.secondary">
            Loading...
          </Typography>
        </Box> : <>

      <Typography sx={{ fontSize: "14px", color: "#616161", mb: 3, pl: 1 }}>
        Total Sign-Ups: <b>{totalUsers.toLocaleString()}</b>
      </Typography>

      <Box sx={{ display: "flex", gap: 3, alignItems: "center" }}>

        {/* LEFT — Dynamic List */}
        <Box sx={{ width: "40%" }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, }}>
            {platformData.map((item, index) => (
              <Box
                key={index}
                sx={{
                  py: 1.5,
                  px: 1.5, borderRadius: '8px',
                  border: "1px solid #e6e6e6",
                  display: "flex", alignItems: 'center',
                  justifyContent: "space-between",
                }}
              >
                <Box>
                  <Typography sx={{ color: "#3E3E3E", fontSize: "16px", display: 'flex', gap: 1.5, alignItems: 'center', mb: 1.5 }}>
                    {item.icon} {item.label}
                  </Typography>
                  <Typography
                    sx={{
                      color: "#3C4043",
                      fontSize: "24px",
                      fontWeight: 600,
                    }}
                  >
                    {item.value.toLocaleString()}
                  </Typography>
                </Box>

                <Typography
                  variant="span" sx={{ fontSize: '14px', color: '#3E3E3E', fontWeight: '500', border: '1px solid #ccc', borderRadius: 1, padding: '3px 10px' }}
                >
                  {item.percent}%
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>

        {/* RIGHT — Pie Chart */}
        <Box sx={{ width: "60%" }}>
          <HighchartsReact highcharts={Highcharts} options={pieOptions} />
        </Box>
      </Box>
        </>}

    </Box>
  );
}
